module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Duerrenaesch-7ec91de79443bd9839f9ed3bc3ef2222.svg";